<template>
  <div
    :class="overlayClasses"
    class="w-full h-full top-0 left-0 z-100 flex justify-center"
  >
    <div class="place-self-center">
      <svg
        class="animate-spin-loader w-loader h-loader m-auto bg-transparent block"
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid"
      >
          <circle
            class="stroke-signableBlue"
            cx="50"
            cy="50"
            r="32"
            fill="none"
            stroke-width="3"
            stroke-dasharray="50 50"
            stroke-linecap="round"
          />
      </svg>
      <div
        v-show="statusText"
        class="text-center text-lg text-signablePrimary1"
      >
        {{ statusText }}
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue';

export default defineComponent({
  name: 'LoadingSpinner',
  props: {
    opaque: {
      type: Boolean,
      required: false,
      default: false,
    },
    fullscreen: {
      type: Boolean,
      required: false,
      default: false,
    },
    statusText: {
      type: String,
      required: false,
    },
  },
  setup(props) {
    // eslint-disable-next-line arrow-body-style
    const overlayClasses = computed(() => {
      return {
        fixed: props.fullscreen,
        absolute: !props.fullscreen,
        'bg-white': props.opaque,
        'bg-loaderTransparent': !props.opaque,
      };
    });

    return {
      overlayClasses,
    };
  },
});
</script>
